import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import {
  Navigation,
  HeroSection,
  ServicesSection,
  AboutSection,
  WhyChooseUsSection,
  ServiceAreasSection,
  SaleSection,
  ComplaintSection,
  HvacAuditSection,
  TonnageCalculatorSection,
  CareerSection,
  ContactSection,
  ServiceSetsSection,
  Footer,
  FloatingWhatsAppButton
} from "@/components/sections";

// Main Home Component
const Home = () => {
  return (
    <div className="min-h-screen" data-testid="home-page">
      <Navigation />
      <HeroSection />
      <ServicesSection />
      <ComplaintSection />
      <SaleSection />
      <HvacAuditSection />
      <TonnageCalculatorSection />
      <AboutSection />
      <WhyChooseUsSection />
      <ServiceAreasSection />
      <CareerSection />
      <ContactSection />
      <ServiceSetsSection />
      <Footer />
      <FloatingWhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
